import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../booking/AuthContext";
import { LayoutDashboard, FolderOpen, ConciergeBell, Users, Armchair, Tags, Settings, LogOut, CalendarDays, Waves, Star, BarChart3 } from "lucide-react";
import { Button } from "../../components/ui/button";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/calendar", icon: Waves, label: "Calendar" },
  { to: "/admin/bookings", icon: CalendarDays, label: "Bookings" },
  { to: "/admin/revenue", icon: BarChart3, label: "Revenue" },
  { to: "/admin/regulars", icon: Star, label: "Regulars" },
  { to: "/admin/categories", icon: FolderOpen, label: "Categories" },
  { to: "/admin/services", icon: ConciergeBell, label: "Services" },
  { to: "/admin/providers", icon: Users, label: "Providers" },
  { to: "/admin/resources", icon: Armchair, label: "Resources" },
  { to: "/admin/statuses", icon: Tags, label: "Statuses" },
  { to: "/admin/settings", icon: Settings, label: "Settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-stone-100 flex flex-col md:flex-row">
      <aside className="md:w-60 bg-[#15262d] text-white flex md:flex-col md:min-h-screen overflow-x-auto">
        <div className="hidden md:block px-5 py-6">
          <img src="/logo-sand.png" alt="Tribe" className="h-8" />
          <p className="text-[10px] uppercase tracking-widest text-white/50 mt-2">Booking Back-office</p>
        </div>
        <nav className="flex md:flex-col flex-1 md:px-3 gap-1 p-2 md:p-0">
          {NAV.map(({ to, end, icon: Icon, label }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm whitespace-nowrap transition-colors ${
                  isActive ? "bg-white/15 text-white" : "text-white/60 hover:text-white hover:bg-white/5"
                }`
              }>
              <Icon size={16} /> <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="md:px-3 md:pb-5 p-2">
          <button data-testid="admin-logout" onClick={async () => { await logout(); navigate("/admin/login"); }}
            className="flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-white/60 hover:text-white hover:bg-white/5 w-full">
            <LogOut size={16} /> <span className="hidden md:inline">Sign out</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 p-4 md:p-8 max-w-6xl w-full mx-auto">
        <div className="flex justify-between items-center mb-6">
          <span className="text-xs text-muted-foreground">{user.email} · {user.role}</span>
          <Button variant="outline" size="sm" onClick={() => window.open("/book", "_blank")}>View booking page</Button>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
